import useLenis from '../hooks/useLenis';
import Nav from '../components/Nav';
import Hero from '../components/Hero';
import Marquee from '../components/Marquee';
import About from '../components/About';
import PhotoStrip from '../components/PhotoStrip';
import FieldNotes from '../components/FieldNotes';
import OpsDashboard from '../components/OpsDashboard';
import CaseStudies from '../components/CaseStudies';
import OpenTickets from '../components/OpenTickets';
import Footer from '../components/Footer';
import ScrollBuddy from '../components/ScrollBuddy';

export default function Home() {
  useLenis();
  return (
    <div className="grain" data-testid="home-page">
      <Nav />
      <ScrollBuddy />
      <main>
        <Hero />
        <Marquee />
        <About />
        <PhotoStrip />
        <FieldNotes />
        <OpsDashboard />
        <CaseStudies />
        <OpenTickets />
      </main>
      <Footer />
    </div>
  );
}
